import axios from "axios";
import { mapGetters, mapActions } from 'vuex';
export default {
    methods: {
        ...mapActions(['setSnackbar']),
        async buscarEquipoCliente(codCliente){
            try{
                let respuesta = await axios.get(`/api/tecnicosCliente?cliente_id=${codCliente}`);
                let tecnicosCliente = respuesta.data[0];
                if (!this.tecnicos.length) {
                    await this.$store.dispatch("usuarios/getUsuarios");
                }
                return {
                    'responsableCuenta': this.tecnicos.find(tecnico => tecnico.email === tecnicosCliente.responsableCuenta),
                    'tecnicoReferencia': this.tecnicos.find(tecnico => tecnico.email === tecnicosCliente.tecnicoReferencia),
                    'equipoTecnico': this.getEquipoTecnico(tecnicosCliente.equipo)
                };
            }catch(error){
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido recuperar los datos de Dynamics'
                });
                return {
                    error: true
                }
            }
        },
        getEquipoTecnico(zonaVenta){
            let relacionEquiposZonaVenta = [
                {
                    zonaVentaId: "062cbce0-8445-e911-a98e-000d3ab7d7be",
                    equipoId: 1 //AZUL
                },
                {
                    zonaVentaId: "002cbce0-8445-e911-a98e-000d3ab7d7be",
                    equipoId: 2 //VERDE
                },
                {
                    zonaVentaId: "022cbce0-8445-e911-a98e-000d3ab7d7be",
                    equipoId: 3 //NARANJA
                },
                {
                    zonaVentaId: "042cbce0-8445-e911-a98e-000d3ab7d7be",
                    equipoId: 4 //AMARILLO
                },
            ];
            let relacion = relacionEquiposZonaVenta.find(relacion => relacion.zonaVentaId === zonaVenta);
            if(relacion){
                return this.tecnicos.filter(tecnico => tecnico.equipos.some(equipo => equipo.id === relacion.equipoId));
            }else{
                return undefined;
            }
        }
    },
    computed: {
        ...mapGetters({tecnicos: "usuarios/tecnicos"})
    }
}